<template>
    <div class="accordion" :class="{ 'accordion--open': open }">
        <div class="accordion__header" @click="open = !open">
            <slot name="header">
                <span class="accordion__label">{{ label }}</span>
            </slot>
            <span class="accordion__chevron">&#8250;</span>
        </div>
        <div class="accordion__body" v-show="open">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class Accordion extends Vue {
    @Prop({ default: '' }) label!: string;
    @Prop({ default: false }) startOpen!: boolean;

    open = false;

    created() {
        this.open = this.startOpen;
    }
}
</script>

<style scoped>
.accordion {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    overflow: hidden;
}

.accordion__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    cursor: pointer;
    user-select: none;
    background: #f8f9fa;
    gap: 8px;
}

.accordion__header:hover {
    background: #e9ecef;
}

.accordion__label {
    font-weight: 500;
    font-size: 0.9rem;
}

.accordion__chevron {
    font-size: 1.3rem;
    line-height: 1;
    color: #6c757d;
    transform: rotate(90deg);
    transition: transform 0.2s ease;
}

.accordion--open .accordion__chevron {
    transform: rotate(270deg);
}

.accordion__body {
    padding: 12px 14px;
    border-top: 1px solid #dee2e6;
    background-color: white;
}
</style>
